import { GetAllFlightItinerariesState } from './getAllFlightItineraries.types'

const initialState: GetAllFlightItinerariesState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
